import { isEqual, isValid } from "date-fns";
import {
  ColumnTranslKeys,
  TranslationsByKeys,
} from "src/components/molecules/modals/TranslationsModal/types";
import { TableColumn } from "src/requests/table/types";
import { SelectItem, Tuple } from "../../../../../globalTypes";
import {
  TypeSpecificValueFormat,
  ValueFormat,
} from "../../../../../requests/templates/types";
import { isDateEqual, isDateInRange } from "../../../../../utils/dateTime";
import { isNumber, isNumberInRange } from "../../../../../utils/generalUtils";
import {
  DATETIME,
  TIME,
} from "../../../../organisms/TemplateBuilder/TemplateItemEditor/FormatEditor/constants";
import { DateViewFormat } from "../../FlowioDateInput";

const doesOptionMatch = (
  option: SelectItem,
  value: number | string,
  typeSpecificFormat?: TypeSpecificValueFormat
) => {
  const { isRange, rangeValue } = option;
  const isValueNumber = isNumber(value);

  if (isValueNumber) {
    if (isRange) {
      return isNumberInRange(
        rangeValue as Tuple<number | null>,
        value as number
      );
    }
    return String(value) === option.value;
  }

  if (isRange) {
    return isDateInRange(rangeValue as Tuple<string | null>, value as string);
  }

  const mValue = new Date(value);

  if (isValid(mValue)) {
    return isDateEqual(option.value, value, typeSpecificFormat?.date?.variant);
  }

  return option.value === value;
};

export const matchSelectItem = (
  options: SelectItem[],
  value: string | number | null | undefined,
  typeSpecificFormat?: TypeSpecificValueFormat
) => {
  if (value === null || value === undefined) return null;
  return options.find((option) =>
    doesOptionMatch(option, value, typeSpecificFormat)
  );
};

export const couldBeColorInput = (format: ValueFormat, editable: boolean) =>
  format?.general?.asColor && format.general?.colorOptions && !editable;

export const couldBeIconInput = (format: ValueFormat, editable: boolean) =>
  format?.general?.asIcon && format?.general?.iconOptions && !editable;

export const determineDateView = (format?: ValueFormat): DateViewFormat => {
  const variant = format?.typeSpecific.date?.variant;
  if (!variant) return "full";
  if ([TIME, DATETIME].includes(variant)) return "full";
  return "day only";
};

const getColKeyFromColumnForTranslations = (column: TableColumn) => {
  const colKey = column.withTemplateUniqueName;
  const firstLetter = colKey[0].toLowerCase();

  return `${firstLetter}${colKey.slice(1)}` as ColumnTranslKeys;
};

export const getTranslationsAndColKeyForColumn = (
  translations: TranslationsByKeys | undefined,
  column: TableColumn
) => {
  if (!translations) return undefined;
  const colKey = getColKeyFromColumnForTranslations(column);

  return { translations: translations[colKey], colKey };
};
